module.exports = __webpack_public_path__ + "assets/superiorWork.6f1ae1e5.svg";